import { DEFAULT_SHEET_NAME } from "../constants";
import type { TemplatesValue } from "../types";
import { MEDIUM_ITEM_SIZE } from "./_fields";
import { validatePlainText } from "./_utils";

type AccidentInvestigationRecordTemplate = {
  eName: string;
  eJobTitle: string;
  eDepartment: string;
};

export const accidentInvestigationRecordTemplate: TemplatesValue<AccidentInvestigationRecordTemplate> =
  {
    fileName: "DanhSachThongTinNguoiThamGiaDieuTra",
    sheet: DEFAULT_SHEET_NAME,
    structures: [
      {
        header: "Họ và tên",
        value: "",
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validatePlainText,
      },
      {
        header: "Chức danh",
        value: "",
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validatePlainText,
      },
      {
        header: "Cơ quan công tác",
        value: "",
        itemSize: MEDIUM_ITEM_SIZE,
        validate: validatePlainText,
      },
    ],
    fields: ["eName", "eJobTitle", "eDepartment"],
  };
